var map = {
	"./airplane.svg": 687,
	"./anchor.svg": 688,
	"./atsign.svg": 689,
	"./attractions.svg": 690,
	"./baby.svg": 691,
	"./backpack.svg": 692,
	"./bathing.svg": 693,
	"./beach.svg": 694,
	"./bed.svg": 695,
	"./biscuit.svg": 696,
	"./boat.svg": 697,
	"./branch.svg": 698,
	"./cab.svg": 699,
	"./camera.svg": 700,
	"./camper.svg": 701,
	"./camping.svg": 702,
	"./carfront.svg": 703,
	"./check.svg": 704,
	"./chef.svg": 705,
	"./christmastree.svg": 706,
	"./cloudy.svg": 707,
	"./cocktail.svg": 708,
	"./compass.svg": 709,
	"./crate.svg": 710,
	"./culture.svg": 711,
	"./cup.svg": 712,
	"./cycle.svg": 713,
	"./doublebed.svg": 714,
	"./downhillskiing.svg": 715,
	"./duck.svg": 716,
	"./easteregg.svg": 717,
	"./ecohome.svg": 718,
	"./farmersmarket.svg": 719,
	"./ferja.svg": 720,
	"./fish.svg": 721,
	"./flower.svg": 722,
	"./food.svg": 723,
	"./gamlebyen.svg": 724,
	"./gamlebystjerne.svg": 725,
	"./golf.svg": 726,
	"./grain.svg": 727,
	"./grapes.svg": 728,
	"./handball.svg": 729,
	"./handshake.svg": 730,
	"./heart.svg": 731,
	"./helleristning.svg": 732,
	"./hike.svg": 733,
	"./house.svg": 734,
	"./hut.svg": 735,
	"./hvaler.svg": 736,
	"./icecream.svg": 737,
	"./info.svg": 738,
	"./leaf.svg": 739,
	"./listing.svg": 740,
	"./lovecamera.svg": 741,
	"./lovesong.svg": 742,
	"./mail.svg": 743,
	"./map.svg": 744,
	"./meeting.svg": 745,
	"./musicnotes.svg": 746,
	"./open.svg": 747,
	"./organic.svg": 748,
	"./oscarsborg.svg": 749,
	"./oscarsborgferry.svg": 750,
	"./painting.svg": 751,
	"./palette.svg": 752,
	"./park.svg": 753,
	"./parking.svg": 754,
	"./picnic.svg": 755,
	"./play.svg": 756,
	"./pram.svg": 757,
	"./present.svg": 758,
	"./presentation.svg": 759,
	"./railway.svg": 760,
	"./reading.svg": 761,
	"./recycling.svg": 762,
	"./romantic.svg": 763,
	"./santa.svg": 764,
	"./saunas.svg": 765,
	"./saveplanet.svg": 766,
	"./shoppingbag.svg": 767,
	"./shrimp.svg": 768,
	"./shuttle.svg": 769,
	"./sign.svg": 770,
	"./skating.svg": 771,
	"./slippers.svg": 772,
	"./snow.svg": 773,
	"./snowman.svg": 774,
	"./spa.svg": 775,
	"./specialoffer.svg": 776,
	"./starrating.svg": 777,
	"./steps.svg": 778,
	"./strawberry.svg": 779,
	"./sun.svg": 780,
	"./takeoff.svg": 781,
	"./toast.svg": 782,
	"./tree.svg": 783,
	"./truck.svg": 784,
	"./vaerste.svg": 785,
	"./vdologo.svg": 786,
	"./vdologoguide.svg": 787,
	"./vfhlogo.svg": 788,
	"./vgologo.svg": 789,
	"./vgologoguide.svg": 790,
	"./vikings.svg": 791,
	"./wateringplant.svg": 792,
	"./world.svg": 793,
	"./yoga.svg": 794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;